import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {

    transform(value: any, format?: any): any {
        if (format === 'parse') {
            return moment(value).toDate();
        }
        else if (format === 'ago')
            return moment(value).fromNow();
        else
            return moment(value).format(format);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/moment.pipe.ts